import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { PageHeader, SectionPad, Badge } from "../../components/ui-extras";
import { Trash } from "@phosphor-icons/react";
import { useAuth } from "../../lib/auth";

export default function Users() {
  const { user: me } = useAuth();
  const [rows, setRows] = useState([]);
  const [customers, setCustomers] = useState([]);

  const load = async () => {
    const [u, c] = await Promise.all([api.get("/users"), api.get("/customers")]);
    setRows(u.data); setCustomers(c.data);
  };
  useEffect(() => { load(); }, []);

  const save = async (u, patch) => {
    try {
      await api.put(`/users/${u.user_id}`, { role: patch.role ?? u.role, customer_id: patch.customer_id ?? u.customer_id });
      toast.success("User updated"); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  const del = async (u) => {
    if (!window.confirm(`Delete ${u.email}?`)) return;
    try { await api.delete(`/users/${u.user_id}`); toast.success("Deleted"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <SectionPad>
      <PageHeader
        title="Users"
        subtitle="ACCESS / USERS"
        testId="users-header"
      />
      <div className="gf-card">
        <div className="gf-card-header">
          <h3>{rows.length} users</h3>
          <div className="overline">SIGNED IN USERS WILL APPEAR HERE AUTOMATICALLY</div>
        </div>
        <table className="gf-table">
          <thead><tr><th>USER</th><th>EMAIL</th><th>ROLE</th><th>CUSTOMER (for customer role)</th><th>CREATED</th><th></th></tr></thead>
          <tbody>
            {rows.map((u) => (
              <tr key={u.user_id} data-testid={`user-row-${u.user_id}`}>
                <td>
                  <div className="font-medium">{u.name}</div>
                  {u.user_id === me?.user_id && <Badge variant="info">YOU</Badge>}
                </td>
                <td className="font-mono text-xs">{u.email}</td>
                <td>
                  <select
                    className="gf-input"
                    style={{ width: 140 }}
                    value={u.role}
                    onChange={(e) => save(u, { role: e.target.value })}
                    disabled={u.user_id === me?.user_id}
                    data-testid={`role-select-${u.user_id}`}
                  >
                    <option value="admin">admin</option>
                    <option value="customer">customer</option>
                  </select>
                </td>
                <td>
                  <select
                    className="gf-input"
                    style={{ width: 240 }}
                    value={u.customer_id || ""}
                    onChange={(e) => save(u, { customer_id: e.target.value || null })}
                    disabled={u.role !== "customer"}
                  >
                    <option value="">— not linked —</option>
                    {customers.map((c) => <option key={c.customer_id} value={c.customer_id}>{c.company_name}</option>)}
                  </select>
                </td>
                <td className="font-mono text-xs">{(u.created_at || "").slice(0, 10)}</td>
                <td className="text-right">
                  <button className="gf-btn gf-btn-ghost" onClick={() => del(u)} disabled={u.user_id === me?.user_id} data-testid={`delete-user-${u.user_id}`}><Trash size={14}/></button>
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="text-center text-zinc-400 py-8">Users appear here after they sign in for the first time.</td></tr>}
          </tbody>
        </table>
      </div>

      <div className="mt-6 gf-card">
        <div className="gf-card-body">
          <div className="overline mb-2">HOW ROLES WORK</div>
          <ul className="text-sm text-zinc-600 space-y-1 list-disc pl-5">
            <li>The <b>first</b> Google account to sign in automatically becomes admin (bootstrap).</li>
            <li>Any email in the <code className="font-mono text-xs bg-zinc-100 px-1">ADMIN_EMAILS</code> allowlist becomes admin on first sign-in.</li>
            <li>All other sign-ins land in the customer portal. Link them to a customer company using the dropdown above.</li>
            <li>To add a customer user before they sign in, create an entry in the <code className="font-mono text-xs bg-zinc-100 px-1">customer_users</code> collection (email → customer_id) via the customer detail page (coming next).</li>
          </ul>
        </div>
      </div>
    </SectionPad>
  );
}
